module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f616.1153efa6.svg";